import { useState } from "react";

const faqItems = [
  {
    question: "Comment rentabiliser une villa avec piscine a La Reunion sans promesse irrealisable ?",
    answer:
      "En travaillant sur des leviers concrets: visibilite de l'annonce, rapidite de reponse, positionnement tarifaire et organisation administrative. L'objectif est d'ameliorer la regularite de vos reservations, pas de promettre un revenu garanti.",
  },
  {
    question: "Comment eviter les reservations perdues en location saisonniere a La Reunion ?",
    answer:
      "Les pertes viennent souvent de reponses tardives, d'annonces peu claires ou d'un suivi incomplet. Nous mettons en place un cadre simple: messages plus rapides, annonce mieux structuree et processus de suivi plus rigoureux.",
  },
  {
    question: "Comment ameliorer la visibilite d'une location courte duree a La Reunion ?",
    answer:
      "En clarifiant votre positionnement (type de bien, capacite, atouts), en optimisant vos contenus d'annonce et en gardant une coherence entre plateformes. Cela aide a attirer des voyageurs plus qualifies.",
  },
  {
    question: "Pourquoi la reponse rapide change tout sur Airbnb et Booking ?",
    answer:
      "Parce que les voyageurs comparent plusieurs biens en meme temps. Une reponse rapide et claire augmente vos chances d'etre choisi, surtout sur des biens premium comme les villas avec piscine.",
  },
  {
    question: "Deleg.ai, c'est pour quel type de proprietaire ?",
    answer:
      "Pour les proprietaires de villas a La Reunion qui recherchent une expertise locale, souvent sur des capacites de 4 a 6 voyageurs minimum, et qui veulent deleguer l'operationnel administratif et commercial sans perdre la maitrise de leur bien.",
  },
];

export default function FaqDeleg() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section style={styles.section}>
      <h2 style={styles.title}>FAQ proprietaires - clair, simple, concret</h2>

      <div style={styles.faqContainer}>
        {faqItems.map((item, index) => (
          <div key={index} style={styles.item}>
            <button
              style={styles.question}
              onClick={() =>
                setOpenIndex(openIndex === index ? null : index)
              }
            >
              {item.question}
              <span style={styles.icon}>
                {openIndex === index ? "−" : "+"}
              </span>
            </button>

            {openIndex === index && (
              <div style={styles.answer}>{item.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  section: {
    maxWidth: "900px",
    margin: "80px auto 40px",
    padding: "0 20px",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "30px",
    textAlign: "center",
    color: "#1E2A38",
  },
  faqContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  item: {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
    overflow: "hidden",
  },
  question: {
    width: "100%",
    padding: "18px 20px",
    background: "none",
    border: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    color: "#1E2A38",
  },
  icon: {
    fontSize: "22px",
    lineHeight: "1",
  },
  answer: {
    padding: "0 20px 18px",
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#2A2A2A",
  },
};
